import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import i18n from '@/lang'; // 引入国际化

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },

  {
    path: '/sustainability',
    name: 'sustainability',
    component: () => import('../views/sustainability.vue'),
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/serviceView.vue'),
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('../views/solution.vue'),
    children: [
      {
        path: '',
        name: 'datacenter',
        component: () => import('../views/pages/datacenter.vue'),
      },
      {
        path: 'store',
        name: 'store',
        component: () => import('../views/pages/store.vue'),
      },
      {
        path: 'charging',
        name: 'charging',
        component: () => import('../views/pages/Charging.vue'),
      },
      {
        path: 'photovoltaic',
        name: 'photovoltaic',
        component: () => import('../views/pages/photovoltaic.vue'),
      },
      {
        path: 'windpower',
        name: 'windpower',
        component: () => import('../views/pages/windpower.vue'),
      },
    ],
  },
  {
    path: '/bess',
    name: 'bess',
    component: () => import('../views/brochure/bess.vue'),
  },
  {
    path: '/transformer',
    name: 'transformer',
    component: () => import('../views/brochure/transformer.vue'),
  },
  {
    path: '/chargingEquipment',
    name: 'chargingEquipment',
    component: () => import('../views/brochure/chargingEquipment.vue'),
  },
  {
    path: '/powerStation',
    name: 'powerStation',
    component: () => import('../views/brochure/powerStation.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/manufacturers',
    name: 'manufacturers',
    component: () => import('../views/manufacturers.vue'),
  },
  {
    path: '/aidc',
    name: 'aidc',
    component: () => import('../views/Aidc.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // 从语言包自动获取当前语言的标题
  const pageTitle = i18n.t(`nav.${to.name}`);

  // 全局后缀（你们官网英文 slogan）
  const suffix = 'Green Energy · Clean Power for All';

  // 设置浏览器标题
  document.title = pageTitle + ' | ' + suffix;

  next();
});
export default router;
